import { ChatMember, ChatUser } from "../types"

export function isMemberModerator(member?: ChatMember): boolean {
  return member?.is_moderator || false
}

export function isMemberOwner(member: ChatMember): boolean {
  return member?.role === 'owner' || false
}

export function membersToUserList(members: ChatMember[]): ChatUser[] {
  return members.map(member => {
    const isModerator = isMemberModerator(member)
    const isOwner = isMemberOwner(member)
    const role = (isModerator || isOwner) ? 'Admin' : null

    return  {
      ...member.user,
      id: member.user_id, 
      role,
      icon: 'chevron-right',
    }
  })
}

export function memberName(memberName: string): string {
  const name = memberName?.trim()
  if (!name) return 'Unknown'
  return name
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}